import angular from 'angular';
import emailSubjectField from './emailSubjectField';
import './style.scss';

export default angular
  .module('emailSubjectField', [])
  .component('emailSubjectField', emailSubjectField).name;
